import { FunctionComponent } from 'react';
import { ArrowRight } from '@/icons';

import { TypeArrowTextProps } from './types';

/**
 * Arrow Text
 */
export const ArrowText: FunctionComponent<TypeArrowTextProps> = ({
  className,
  labelArrow,
}: TypeArrowTextProps) => (
  <div className={`flex items-center ${className}`}>
    <ArrowRight width={24} height={19} />
    <div className="ml-3 text-subtitle text-subtitle--m whitespace-nowrap">
      {labelArrow}
    </div>
  </div>
);

ArrowText.displayName = 'ArrowText';
